module.exports = __webpack_public_path__ + "img/iconoffice.1e263d55.svg";